import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { AUTH_TOKEN_REDUCER_PATH } from '@bbkAdminRedux/rtkq/auth-status';

/**
 * In-memory holder for the authenticity token captured during sign-in.
 *
 * The post-login validation (see `useSetBBAuthenticityToken`) fetches
 * `/api/current_user` through a non-caching request so it does not populate the
 * global `getCurrentUser` query (which would flip `selectAuthStatus` to
 * authenticated while still on the sign-in page and mount the logged-in tree
 * prematurely). The token is stashed here so the company-creation POSTs that
 * run before the trailing hard navigation can still send
 * `BBK-Authenticity-Token`. Memory-only (not persisted): a reload clears it and
 * the boot probe repopulates the query cache.
 */
type AuthTokenState = {
  token?: string;
};

const initialState: AuthTokenState = {};

export const authTokenSlice = createSlice({
  name: AUTH_TOKEN_REDUCER_PATH,
  initialState,
  reducers: {
    setAuthToken: (state, { payload }: PayloadAction<string>) => {
      state.token = payload;
    },
    clearAuthToken: (state) => {
      state.token = undefined;
    },
  },
});

export const { setAuthToken, clearAuthToken } = authTokenSlice.actions;
